import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../IFITrackerContext/types'
import { alphabeticalCompare } from 'shared'
import { HelpMessage } from 'utils/constants'
import { SortOptions } from 'components/CIMSTable/CIMSColumn/types/sort'
import { dateFormatter } from '../../../../../../../../../../utils/dateFormatter'

export function useReportDate(
  options: Required<Pick<SortOptions<IdentifiedFieldIssue>, 'priority'>>
): CIMSSingleColumn<IdentifiedFieldIssue> {
  return {
    title: 'Report Date',
    render: ({ reportDate }) => dateFormatter.datetime(reportDate),
    width: 165,
    help: HelpMessage.IdentifiedFieldIssues.IFITracker.ReportDate,
    sort: {
      ...options,
      with: 'callback',
      default: 'ascend',
      onCompare: (a, b) => alphabeticalCompare(a.reportDate, b.reportDate),
    },
    filter: {
      type: 'date',
      with: 'value',
      value: ({ reportDate }) => reportDate,
    },
  }
}
